export interface IDateFilter {
  date: Date;
}

export interface ICustomDateFilter extends IDateFilter {
  id: DateFilterId;
}

export enum DateFilterId {
  Today = "today",
  Yesterday = "yesterday",
  TwoDaysAgo = "two_days_ago",
  ThreeDaysAgo = "three_days_ago",
  CustomDate = "custom_date",
}

export const DateFilterFormatedValues = {
  [DateFilterId.Today]: "Today",
  [DateFilterId.Yesterday]: "Yesterday",
  [DateFilterId.CustomDate]: "Custom date",
};
